import React from 'react';

import ProjectContainer from 'containers/project-container';

import AvatarBase from 'components/avatar-base';

const ProjectAvatar = ({ id, size }) => (
    <ProjectContainer id={id}>
        {
            ({ logo, initials, color, secondary_color }) => (
                <AvatarBase size={size} image={logo} text={initials} color={color} secondaryColor={secondary_color} />
            )
        }
    </ProjectContainer>
);

export default ProjectAvatar;
